<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog
      :title="editItem.Id ? $t('servicesystem.common_objects.commonterms.edit_object', { okey: entity }) : $t('servicesystem.common_objects.commonterms.new_object', { okey: entity })"
      :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger">

      <template v-slot:content>
        <v-container class="px-4" v-if="editItem" :key="dialogtrigger">
          <v-row no-gutters>
            <v-col cols="12" v-if="!isParentStatus">
              <QAutoComplete v-model="editItem.ParentId" :label="$t('servicesystem.common_objects.job.status')"
                :list="statuses" :externaledit="!editItem.Id" :disabled="!!editItem.Id" :textkey="'Name'"
                :valuekey="'Id'" :rules="[requiredRule]">
              </QAutoComplete>
            </v-col>
            <v-col cols="12">
              <QTextField v-model="editItem.Name" :label="$t('servicesystem.common_objects.lead.lead_type_name')"
                maxlength="50" clearable externaledit :rules="[requiredRule]">
              </QTextField>
            </v-col>
            <v-col v-if="!isParentStatus" cols="12" class="my-3">
              <QCheckboxInput v-model="editItem.IsActive"
                :label="$t('servicesystem.common_objects.commonterms.is_active')" externaledit>
              </QCheckboxInput>
            </v-col>
            <v-col v-if="isParentStatus" cols="12" class="my-3">
              <QTextField v-model="editItem.Icon" :label="$t('servicesystem.common_objects.commonterms.icon')" clearable
                externaledit allowexternaloverride>
                <template v-slot:prepend-outer>
                  <IconPickerMenu :value="editItem.Icon || 'mdi-briefcase'" :size="20"
                    @changed="(icon) => { editItem.Icon = icon; }">
                  </IconPickerMenu>
                </template>
              </QTextField>
            </v-col>
            <v-col v-if="isParentStatus" cols="12">
              <QTextField v-model="editItem.Color" :label="$t('servicesystem.common_objects.commonterms.color')"
                clearable externaledit allowexternaloverride>
                <template v-slot:prepend-outer>
                  <ColorPickerMenu :value="editItem.Color" @changed="(color) => { editItem.Color = color; }">
                  </ColorPickerMenu>
                </template>
              </QTextField>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn color="primary" outlined v-text="$t('servicesystem.common_objects.commonterms.cancel')"
          @click="closetrigger++">
        </v-btn>
        <v-btn :disabled="!valid" :color="valid ? 'primary' : 'disabled'" @click="valid ? save() : null">
          {{ $t('servicesystem.common_objects.commonterms.save') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import ColorPickerMenu from "@/components/Menus/ColorPickerMenu.vue";
import IconPickerMenu from '@/components/Menus/IconPickerMenu.vue';

export default {
  name: "EditJobStatusDialog",
  props: {
    externaltrigger: Number,
    item: Object,
  },
  components: {
    SlottedDialog,
    ColorPickerMenu,
    IconPickerMenu
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      editItem: {},
      valid: false,
      loading: false,
    };
  },

  mounted() {
    this.parseItem();
  },

  methods: {
    parseItem() {
      this.editItem = Object.assign({}, this.item);
    },

    async save() {
      this.loading = true;
      var method;
      if (!this.item.ParentId) {
        method = this.changeJobStatus
      }
      else if (this.editItem.Id) {
        method = this.changeJobSubStatus
      }
      else {
        method = this.addJobSubStatus
      }
      await method(this.editItem)
        .then((response) => {
          response.changed = true;
          this.$emit("Update", response);
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  computed: {
    isParentStatus() {
      return this.editItem && !this.editItem.ParentId;
    },

    entity() {
      return this.isParentStatus ? this.$t("servicesystem.common_objects.job.status") : this.$t("servicesystem.common_objects.job.substatus");
    },

    statuses() {
      return Object.assign([], this.$store.getters["LookUpStore/JobStatusList"]);
    },
  },

  watch: {
    item: {
      deep: true,
      handler() {
        this.parseItem();
      },
    },

    externaltrigger: function () {
      this.dialogtrigger++;
      this.parseItem();
    },
  },
};
</script>